/**
 * Ensures every <a target="_blank"> in a CMS-rendered HTML string carries
 * rel="noopener noreferrer", preventing reverse tabnabbing (QID-150222).
 *
 * Works on server and client — no DOM dependency; pure string processing.
 */
export function addNoopenerToBlankLinks(html: string | null | undefined): string {
    if (!html) return '';
    return html.replace(
        /<a(\s[^>]*?)>/gi,
        (match, attrs) => {
            // Only process links that open in a new tab/window
            if (!/\btarget=["']_blank["']/i.test(attrs)) {
                return match;
            }

            // Already has noopener? Leave it unchanged.
            if (/\bnoopener\b/i.test(attrs)) {
                return match;
            }

            // Has a rel attribute — append noopener noreferrer to its value
            if (/\brel\s*=/i.test(attrs)) {
                const patched = attrs.replace(
                    /(\brel\s*=\s*)(["'])([^"']*)\2/i,
                    (_: string, prefix: string, quote: string, value: string) =>
                        `${prefix}${quote}${value.trimEnd()} noopener noreferrer${quote}`
                );
                return `<a${patched}>`;
            }

            // No rel attribute — inject one
            return `<a${attrs} rel="noopener noreferrer">`;
        }
    );
}
